import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { about } from '../mockData';
import { Card, CardContent } from '../components/ui/card';

const About = () => {
  const { language } = useLanguage();
  const t = about[language];

  return (
    <div className="min-h-screen bg-page py-32">
      <div className="container mx-auto px-8">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-20 animate-fade-in">
          <h1 className="heading-1 text-gold mb-8">{t.title}</h1>
          <p className="body-large text-white/90 mb-6">{t.vision}</p>
          <p className="body-medium text-gray-400">{t.mission}</p>
        </div>

        {/* Focus Areas */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-20">
          {t.focus.map((item, index) => (
            <Card
              key={index}
              className="bg-card-dark border-gold/20 hover:border-gold/50 transition-all duration-300 hover:transform hover:scale-105 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="p-8">
                <h3 className="heading-5 text-gold mb-4">{item.title}</h3>
                <p className="body-small text-gray-300">{item.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Images Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div className="relative overflow-hidden rounded-lg aspect-square animate-fade-in" style={{ animationDelay: '0.3s' }}>
            <img
              src="https://images.unsplash.com/photo-1538922834563-a49edd1ac1a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxzY3JlZW53cml0aW5nfGVufDB8fHx8MTc2OTQ4MTY2NHww&ixlib=rb-4.1.0&q=85"
              alt="Screenwriting"
              className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
            />
          </div>
          <div className="relative overflow-hidden rounded-lg aspect-square animate-fade-in" style={{ animationDelay: '0.4s' }}>
            <img
              src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxjb2xsYWJvcmF0aW9ufGVufDB8fHx8MTc2OTQ4MTY3MHww&ixlib=rb-4.1.0&q=85"
              alt="Collaboration"
              className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
            />
          </div>
          <div className="relative overflow-hidden rounded-lg aspect-square animate-fade-in" style={{ animationDelay: '0.5s' }}>
            <img
              src="https://images.unsplash.com/photo-1764581659101-0c2a38ebe301?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxzY3JlZW53cml0aW5nfGVufDB8fHx8MTc2OTQ4MTY2NHww&ixlib=rb-4.1.0&q=85"
              alt="Cinema"
              className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;